/* ==========================================================================
   Oran theme — global behaviors
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- mobile nav drawer ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var navDrawer = document.querySelector('[data-nav-drawer]');
  var navOverlay = document.querySelector('[data-nav-overlay]');
  function closeNav() {
    if (navDrawer) navDrawer.classList.remove('is-open');
    if (navOverlay) navOverlay.classList.remove('is-open');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
  }
  if (navToggle && navDrawer) {
    navToggle.addEventListener('click', function () {
      var open = navDrawer.classList.toggle('is-open');
      if (navOverlay) navOverlay.classList.toggle('is-open', open);
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (navOverlay) navOverlay.addEventListener('click', closeNav);
    document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) { if (btn !== navToggle) btn.addEventListener('click', closeNav); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });
  }

  /* ---------- sticky header shadow on scroll ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var lastY = 0;
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      lastY = window.scrollY;
    }, { passive: true });
  }

  /* ---------- back to top ---------- */
  var backToTop = document.querySelector('[data-back-to-top]');
  if (backToTop) {
    window.addEventListener('scroll', function () {
      backToTop.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- scroll-reveal animation ---------- */
  var revealEls = document.querySelectorAll('[data-animate]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- generic slideshow (hero / testimonials) ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-slide]');
    var dotsWrap = root.querySelector('[data-slide-dots]');
    var prev = root.querySelector('[data-slide-prev]');
    var next = root.querySelector('[data-slide-next]');
    var live = root.querySelector('[data-slide-live]');
    var index = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);
    var timer = null;

    if (!slides.length) return;

    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'slide-dot';
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.addEventListener('click', function () { show(i); resetTimer(); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
      if (live) live.textContent = 'Slide ' + (index + 1) + ' of ' + slides.length;
    }
    function resetTimer() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { show(index + 1); }, interval);
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); resetTimer(); });
    if (next) next.addEventListener('click', function () { show(index + 1); resetTimer(); });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', resetTimer);

    /* touch swipe */
    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
      startX = null;
      resetTimer();
    }, { passive: true });

    show(0);
    resetTimer();
  });

  /* ---------- horizontal product carousel ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track) return;
    function scrollByCard(dir) {
      var card = track.querySelector('.card');
      var amount = card ? (card.getBoundingClientRect().width + 22) * dir : 300 * dir;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });
  });

  /* ---------- product gallery: thumbnail swap ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        if (main && thumb.dataset.fullSrc) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = thumb.dataset.fullSrc; }
        if (gallery.classList.contains('oran-pdp-hero')) gallery.querySelector('[data-gallery-main]').classList.toggle('is-pack-shot', i === 0);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
      if (i === 0) thumb.classList.add('is-active');
    });
  });

  /* ---------- before / after image slider ---------- */
  document.querySelectorAll('[data-before-after]').forEach(function (root) {
    var handle = root.querySelector('[data-ba-handle]');
    var after = root.querySelector('[data-ba-after]');
    if (!handle || !after) return;
    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      /* FIXED: clip from the left (not the right) so the "after" image is
         revealed on the RIGHT side, matching after_label's position; the
         "before" image (base layer) then shows through on the left, matching
         before_label. Previously this clipped from the right, which put the
         after image on the left — opposite of the labels. */
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }
    function fromEvent(e) {
      var rect = root.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      setPos((x / rect.width) * 100);
    }
    var dragging = false;
    handle.addEventListener('mousedown', function () { dragging = true; });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('mousemove', function (e) { if (dragging) fromEvent(e); });
    handle.addEventListener('touchstart', function () { dragging = true; }, { passive: true });
    window.addEventListener('touchend', function () { dragging = false; });
    window.addEventListener('touchmove', function (e) { if (dragging) fromEvent(e); }, { passive: true });
    setPos(50);
  });

  /* ---------- sticky mobile add-to-cart bar ---------- */
  var mainAtc = document.querySelector('[data-main-atc]');
  var stickyBar = document.querySelector('[data-sticky-atc]');
  if (mainAtc && stickyBar && 'IntersectionObserver' in window) {
    var atcIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    atcIo.observe(mainAtc);
  }

  /* ---------- quantity stepper (product page + quick add) ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="number"]');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  /* ---------- selected bundle uses its own real Shopify product variant ---------- */
  var oranOffers = document.querySelector('[data-oran-offers]');
  if (oranOffers) {
    var updateOfferDisplay = function () {
      var chosen = oranOffers.querySelector('[data-offer-input]:checked');
      if (!chosen) return;
      var price = document.querySelector('[data-pd-price]');
      var stickyPrice = document.querySelector('[data-sticky-offer-price]');
      var stickyTitle = document.querySelector('[data-sticky-offer-title]');
      if (price) price.textContent = chosen.dataset.offerPrice;
      if (stickyPrice) stickyPrice.textContent = chosen.dataset.offerPrice;
      if (stickyTitle) stickyTitle.textContent = chosen.dataset.offerTitle;
    };
    oranOffers.addEventListener('change', updateOfferDisplay);
    updateOfferDisplay();
  }

  /* ---------- cart count badge/text updater ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (el.classList.contains('cart-count')) {
        el.style.display = count > 0 ? '' : 'none';
      }
    });
    document.querySelectorAll('[data-cart-link]').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + count + ' items');
    });
  }

  /* ---------- quick add to cart (product listing cards) ---------- */
  document.querySelectorAll('[data-quick-add]').forEach(function (root) {
    var addBtn = root.querySelector('[data-quick-add-submit]');
    var variantId = root.getAttribute('data-variant-id');
    if (!addBtn || !variantId) return;

    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (addBtn.disabled) return;

      var originalText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
          return res.json();
        })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          addBtn.textContent = 'Added ✓';
          addBtn.classList.add('is-added');
          setTimeout(function () {
            addBtn.textContent = originalText;
            addBtn.classList.remove('is-added');
            addBtn.disabled = false;
          }, 1400);
        })
        .catch(function () {
          addBtn.textContent = 'Try again';
          addBtn.disabled = false;
        });
    });
  });

  /* ---------- cart page: live quantity +/- and remove (AJAX) ---------- */
  var cartItemsRoot = document.querySelector('[data-cart-items]');
  if (cartItemsRoot) {
    var cartBusy = false;

    function formatMoney(cents) {
      return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function renderEmptyCart() {
      cartItemsRoot.innerHTML =
        '<p style="color:var(--ink-soft); margin-top:16px;">Your cart is empty.</p>' +
        '<a href="/collections/all" class="btn btn-primary" style="margin-top:20px;">Continue shopping</a>';
    }

    function applyCartState(cart) {
      updateCartCount(cart.item_count);
      if (cart.item_count === 0) {
        renderEmptyCart();
        return;
      }
      var shipping = cartItemsRoot.querySelector('.oran-shipping-progress');
      if (shipping) {
        var remaining = Math.max(0, 50000 - cart.total_price);
        var shippingText = shipping.querySelector('p');
        if (shippingText) shippingText.innerHTML = remaining > 0
          ? 'Add <strong>' + formatMoney(remaining) + '</strong> more for free delivery on orders above ₹499.'
          : '<strong>You’ve unlocked free delivery!</strong>';
        var bar = shipping.querySelector('.oran-shipping-bar');
        if (bar) bar.setAttribute('aria-valuenow', String(Math.min(500, Math.floor(cart.total_price / 100))));
        var fill = shipping.querySelector('.oran-shipping-bar span');
        if (fill) fill.style.width = Math.min(100, cart.total_price / 500) + '%';
      }
      var rows = cartItemsRoot.querySelectorAll('[data-cart-line-row]');
      rows.forEach(function (row) {
        var key = row.getAttribute('data-cart-line-row');
        var item = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) { item = cart.items[i]; break; }
        }
        if (!item) {
          row.remove();
          return;
        }
        var qtyInput = row.querySelector('[data-cart-qty-input]');
        if (qtyInput) qtyInput.value = item.quantity;
        var priceCell = row.querySelector('[data-cart-line-price]');
        if (priceCell) priceCell.textContent = formatMoney(item.final_line_price);
      });
      var totalEl = cartItemsRoot.querySelector('[data-cart-total]');
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    }

    function cartChange(key, quantity) {
      if (cartBusy) return;
      cartBusy = true;
      cartItemsRoot.style.opacity = '0.5';
      cartItemsRoot.style.pointerEvents = 'none';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { applyCartState(cart); })
        .catch(function () {})
        .then(function () {
          cartBusy = false;
          cartItemsRoot.style.opacity = '';
          cartItemsRoot.style.pointerEvents = '';
        });
    }

    cartItemsRoot.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('[data-cart-qty-minus]');
      var plusBtn = e.target.closest('[data-cart-qty-plus]');
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (!minusBtn && !plusBtn && !removeBtn) return;

      if (removeBtn) {
        var removeKey = removeBtn.getAttribute('data-key');
        cartChange(removeKey, 0);
        return;
      }

      var wrap = (minusBtn || plusBtn).closest('[data-cart-qty]');
      if (!wrap) return;
      var input = wrap.querySelector('[data-cart-qty-input]');
      var key = wrap.getAttribute('data-key');
      var current = parseInt((input && input.value) || '1', 10) || 1;
      var next = minusBtn ? Math.max(0, current - 1) : current + 1;
      if (input) input.value = next;
      cartChange(key, next);
    });
  }

  /* ---------- mobile filter drawer (collection page) ---------- */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.querySelector('[data-filter-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      var open = filterPanel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
});
document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('[data-gallery]').forEach(function(gallery){var main=gallery.querySelector('[data-gallery-main] img');if(!main)return;var lightbox=document.createElement('div');lightbox.className='pd-lightbox';lightbox.innerHTML='<button class="pd-lightbox-close" aria-label="Close">&times;</button><img>';document.body.appendChild(lightbox);var lbImg=lightbox.querySelector('img');var closeBtn=lightbox.querySelector('.pd-lightbox-close');function openLightbox(){lbImg.src=main.src;lightbox.classList.add('is-open');}function closeLightbox(){lightbox.classList.remove('is-open');}main.addEventListener('click',openLightbox);closeBtn.addEventListener('click',closeLightbox);lightbox.addEventListener('click',function(e){if(e.target===lightbox)closeLightbox();});document.addEventListener('keydown',function(e){if(e.key==='Escape')closeLightbox();});});});
